const e = {
  black: "#2e3436",
  red: "#cc0000",
  green: "#4e9a06",
  yellow: "#c4a000",
  blue: "#3465a4",
  magenta: "#75507b",
  cyan: "#06989a",
  white: "#d3d7cf",
  "bright-black": "#555753",
  "bright-red": "#ef2929",
  "bright-green": "#8ae234",
  "bright-yellow": "#fce94f",
  "bright-blue": "#729fcf",
  "bright-magenta": "#ad7fa8",
  "bright-cyan": "#34e2e2",
  "bright-white": "#eeeeec"
}, b = {
  black: "#000000",
  red: "#aa0000",
  green: "#00aa00",
  yellow: "#aa5500",
  blue: "#0000aa",
  magenta: "#aa00aa",
  cyan: "#00aaaa",
  white: "#aaaaaa",
  "bright-black": "#555555",
  "bright-red": "#ff5555",
  "bright-green": "#55ff55",
  "bright-yellow": "#ffff55",
  "bright-blue": "#5555ff",
  "bright-magenta": "#ff55ff",
  "bright-cyan": "#55ffff",
  "bright-white": "#ffffff"
}, f = {
  black: "#000000",
  red: "#cd3131",
  green: "#0dbc79",
  yellow: "#e5e510",
  blue: "#2473c8",
  magenta: "#bc3fbc",
  cyan: "#11a7cd",
  white: "#e5e5e5",
  "bright-black": "#666666",
  "bright-red": "#f14c4c",
  "bright-green": "#23d18b",
  "bright-yellow": "#f5f5430",
  "bright-blue": "#3b8dea",
  "bright-magenta": "#d670d6",
  "bright-cyan": "#29b7db",
  "bright-white": "#e5e5e5"
}, t = {
  black: "#0c0c0c",
  red: "#c50f1e",
  green: "#13a10e",
  yellow: "#c19a00",
  blue: "#0037da",
  magenta: "#891798",
  cyan: "#3a96dd",
  white: "#cccccc",
  "bright-black": "#767676",
  "bright-red": "#e74855",
  "bright-green": "#15c60c",
  "bright-yellow": "#f9f1a5",
  "bright-blue": "#3b79ff",
  "bright-magenta": "#b4009f",
  "bright-cyan": "#61d6d6",
  "bright-white": "#f2f2f2"
}, a = {
  black: "#000000",
  red: "#990000",
  green: "#00a600",
  yellow: "#999900",
  blue: "#0000b2",
  magenta: "#b200b2",
  cyan: "#00a6b2",
  white: "#bfbfbf",
  "bright-black": "#666666",
  "bright-red": "#e60000",
  "bright-green": "#00d900",
  "bright-yellow": "#e6e600",
  "bright-blue": "#0000ff",
  "bright-magenta": "#e600e6",
  "bright-cyan": "#00e6e6",
  "bright-white": "#e6e6e6"
}, r = {
  black: "#000000",
  red: "#bb0000",
  green: "#00bb00",
  yellow: "#bbbb00",
  blue: "#0000bb",
  magenta: "#bb00bb",
  cyan: "#00bbbb",
  white: "#bbbbbb",
  "bright-black": "#555555",
  "bright-red": "#ff5555",
  "bright-green": "#55ff55",
  "bright-yellow": "#ffff55",
  "bright-blue": "#5555ff",
  "bright-magenta": "#ff55ff",
  "bright-cyan": "#55ffff",
  "bright-white": "#ffffff"
}, g = {
  black: "#000000",
  red: "#cd0000",
  green: "#00cd00",
  yellow: "#cdcd00",
  blue: "#0000ee",
  magenta: "#cd00cd",
  cyan: "#00cdcd",
  white: "#e5e5e5",
  "bright-black": "#7f7f7f",
  "bright-red": "#ff0000",
  "bright-green": "#00ff00",
  "bright-yellow": "#ffff00",
  "bright-blue": "#5c5cff",
  "bright-magenta": "#ff00ff",
  "bright-cyan": "#00ffff",
  "bright-white": "#ffffff"
}, c = {
  black: "#010101",
  red: "#de382b",
  green: "#39b54a",
  yellow: "#ffc906",
  blue: "#006eb8",
  magenta: "#762671",
  cyan: "#2cb3e9",
  white: "#cccccc",
  "bright-black": "#808080",
  "bright-red": "#ff0000",
  "bright-green": "#00ff00",
  "bright-yellow": "#ffff00",
  "bright-blue": "#0000ff",
  "bright-magenta": "#ff00ff",
  "bright-cyan": "#00ffff",
  "bright-white": "#ffffff"
}, i = {
  black: "#000000",
  red: "#cd0000",
  green: "#00cd00",
  yellow: "#cdcd00",
  blue: "#0000ee",
  magenta: "#cd00cd",
  cyan: "#00cdcd",
  white: "#e5e5e5",
  "bright-black": "#000000",
  "bright-red": "#ff0000",
  "bright-green": "#00ff00",
  "bright-yellow": "#ffff00",
  "bright-blue": "#5c5cff",
  "bright-magenta": "#ff00ff",
  "bright-cyan": "#00ffff",
  "bright-white": "#ffffff"
}, h = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  eclipse: i,
  putty: r,
  terminalapp: a,
  ubuntu: c,
  vga: b,
  vscode: f,
  windows10: t,
  xterm: g,
  xtermjs: e
}, Symbol.toStringTag, { value: "Module" }));
export {
  f as a,
  g as b,
  h as c,
  i as e,
  r as p,
  a as t,
  c as u,
  b as v,
  t as w,
  e as x
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fancy-ansi/dist/colors-B3F3SizO.js
// module id = null
// module chunks = 